import React from 'react';
import { ITabs } from './interfaces';
import { Tab, Tabs as TabsWrapper } from '../../../../../../components/tabs';
import { useTranslation } from 'react-i18next';

export const Tabs: React.FC<ITabs> = ({
  currentTab = 0,
  showScoreSubmissions,
  showSessionsTab,
  showPhotosTab,
  showActivityTab,
  onChange,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <TabsWrapper activeTab={currentTab} onChange={onChange}>
      <Tab label={t('competitions:portal.details.tabs.feed')} />
      <Tab label={t('competitions:portal.details.tabs.ranking')} />
      {showSessionsTab && (
        <Tab label={t('competitions:portal.details.tabs.sessions')} />
      )}
      {showPhotosTab && (
        <Tab label={t('competitions:portal.details.tabs.photos')} />
      )}
      {showScoreSubmissions && (
        <Tab label={t('competitions:portal.details.tabs.yourParticipation')} />
      )}
      {showActivityTab && (
        <Tab label={t('competitions:portal.details.tabs.activity')} />
      )}
    </TabsWrapper>
  );
};
